import React from 'react';

import SupplierPortalSettingsFieldCreateForm from './SupplierPortalSettingsFieldCreateForm';

import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function SupplierPortalSettingsFieldCreateModal(props) {
    const internalCloseHandler = () => {
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        props.successHandler();
    };

    const close = () => {
        internalCloseHandler();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader title={$t('Create New Field')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                <div className="modal__form-container">
                    <div className={'modal__form-container'}>
                        <SupplierPortalSettingsFieldCreateForm
                            types={props.types}
                            states={props.states}
                            reques={props.request}
                            saveUrl={props.saveUrl}
                            internalCloseHandler={internalCloseHandler}
                            internalSuccessHandler={internalSuccessHandler}
                            fetchData={props.fetchData}
                            field={null}
                            close={internalCloseHandler}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
